import { mountWordCountBadge, unmountWordCountBadge } from './src/word-count';

const PLUGIN_NAME = 'growi-plugin-word-count';
const LOG = `[${PLUGIN_NAME}]`;

declare global {
  interface Window {
    pluginActivators?: Record<
      string,
      { activate: () => void; deactivate: () => void }
    >;
    growiFacade?: unknown;
  }
}

let activated = false;

const activate = (): void => {
  if (activated) return;
  activated = true;
  console.info(`${LOG} activate() called`);
  try {
    mountWordCountBadge();
  } catch (err) {
    console.error(`${LOG} activate failed:`, err);
  }
};

const deactivate = (): void => {
  activated = false;
  try {
    unmountWordCountBadge();
  } catch (err) {
    console.error(`${LOG} deactivate failed:`, err);
  }
};

if (window.pluginActivators == null) {
  window.pluginActivators = {};
}
window.pluginActivators[PLUGIN_NAME] = { activate, deactivate };
console.info(`${LOG} registered to window.pluginActivators`);

window.setTimeout(() => {
  if (!activated) {
    console.warn(`${LOG} activate() was not invoked by host; self-activating.`);
    activate();
  }
}, 2000);
